import { render, staticRenderFns } from "./Statement-count-graph.vue?vue&type=template&id=1c3a1eec&scoped=true"
import script from "./Statement-count-graph.vue?vue&type=script&lang=js"
export * from "./Statement-count-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a1eec",
  null
  
)

export default component.exports